const processOrderPurchaseList = (headers, invoiceItems, payload, transData) => {
  let getHeaders = ''
  let getContent = ''
  for (let i = 0; i < headers.length; i++) {
    getHeaders += `<th class="th-fontsize" width="${headers[i].width}">${headers[i].text}</th>`
  }
  for (let j = 0; j < invoiceItems.length; j++) {
    getContent += `<tr>`
    for (let i = 0; i < headers.length; i++) {
      getContent += `<td class="th-fontsize">${invoiceItems[j][headers[i].value] ? invoiceItems[j][headers[i].value] : '&nbsp;'}</td>`
    }
    getContent += '</tr>'
  }
  return content(getHeaders, getContent, payload, transData)
}
const content = (headers, content, payload, transData) => btoa(unescape(encodeURIComponent(`<!DOCTYPE html>
<html>
  <head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
    <style>
    .footer {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      text-align: center;
    }
    .comments_border_remove td {
      border-top: none !important;
    }
    .table-condensed>tbody>tr:nth-of-type(even) {
      background-color: #f9f9f9;
    }
    thead tr { page-break-inside:avoid; }
    thead tr td { padding: 2.5px !important; word-break: break-word; }
    tbody tr { page-break-inside:avoid; }
    tbody tr td { padding: 2.5px !important; word-break: break-word; }
    .line { border-top: 1px solid #333333 !important; margin-bottom: 5px !important; }
    body {
      font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
      font-size: 16px !important;
    }
    .table-content {
      font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    }
    .header-font-size {
    }
    .table-condensed>tbody>tr>td, .table-condensed>tbody>tr>th, .table-condensed>tfoot>tr>td, .table-condensed>tfoot>tr>th, .table-condensed>thead>tr>td, .table-condensed>thead>tr>th {
      padding-left: 1px !important;
      padding-right: 1px !important;
      padding-top: 2.5px !important;
      padding-bottom: 2.5px !important;
    }
    </style>
  </head>
  <body>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12">
        <table style="width: 100%;">
          <tr>
            <td width="45%" rowspan=2 class="header-font-size" style="vertical-align:top">
              <div>
                <span>${payload.customername || ''}</span><br>
                <span>${payload.customeraddress_address || ''}</span><br>
                ${payload.customeraddress_address2 ? `<span>${payload.customeraddress_address2 || ''}</span><br>` : ''}
                <span>${payload.customeraddress_postcode || ''} ${payload.customeraddress_city || ''}</span><br>
              </div>
            </td>
            <td width="30%">
            </td>
            <td width="25%" style="vertical-align:top">
              <img class="img-responsive pull-right" height="180" width="180" src="https://kilabapi.apphouse.no/kilab_logo.png" alt="kilab">
            </td>
          </tr>
          <tr>
            <td colspan=2>
              <div class="row">
                <div class="col-xs-6 col-xs-offset-1 text-left">

                </div>
                <div class="col-xs-5 text-right">
                <h4 style="font-size:18px"><b>${transData.confirm}</b></h4>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="col-xs-7 header-font-size">
        <div class="row">
          <div class="col-xs-6" style="margin-right: 0px;margin-top: 10px;">
            <span><b>${transData.deliveryAddress}</b></span><br>
            <span>${payload.customername || ''}</span>
            <div>
              <span>${payload.deliveryaddress_address || ''}</span><br>
              ${payload.deliveryaddress_address2 ? `<span>${payload.deliveryaddress_address2 || ''}</span><br>` : ''}
              <span>${payload.deliveryaddress_postcode || ''} ${payload.deliveryaddress_city || ''}</span>
            </div>
          </div>
          <div class="col-xs-6" style="margin-right: 0px;margin-top: 10px;">
            <span style="margin-top: 10px;"><b>${transData.invoiceAddress}</b></span><br>
            <span>${payload.invoicetoname || ''}</span>
            <div>
              <span>${payload.invoiceto_address || ''}</span><br>
              ${payload.invoiceto_address2 ? `<span>${payload.invoiceto_address2 || ''}</span><br>` : ''}
              <span>${payload.invoiceto_postcode || ''} ${payload.invoiceto_city || ''}</span>
            </div>
          </div>
          <div class="col-xs-12" style="margin-top: 15px;">
            <b>${transData.internalCom}:</b><br>
            <span style="white-space: pre-wrap;font-size: 16px;"><b>${payload.internalcomments || ''}</b></span>
          </div>
        </div>
      </div>
      <div class="col-xs-5 header-font-size" style="margin-left: 0px; padding-left: 0px;">
        <hr style="margin: 1px;" />
        <table style="width: 100%">
          <tr>
            <td width="50%">${transData.number}:</td>
            <td width="50%" class="text-right">${payload.number || ''}</td>
          </tr>
          <tr>
            <td width="50%">${transData.customerNum}:</td>
            <td width="50%" class="text-right">${payload.customernumber || ''}</td>
          </tr>
        </table>
        <table style="width: 100%">
          <tr>
            <td width="30%">${transData.saleRef}:</td>
            <td width="70%" class="text-right">${payload.salesreference || ''}</td>
          </tr>
        </table>
        <table style="width: 100%">
          <tr>
            <td width="45%">${transData.ourreference}:</td>
            <td width="55%" class="text-right">${payload.ourreferencename || ''}</td>
          </tr>
          <tr>
            <td>${transData.yourreference}:</td>
            <td class="text-right">${payload.yourreference || ''}</td>
          </tr>
          <tr>
            <td>${transData.contact}:</td>
            <td class="text-right">${payload.contactname || ''}</td>
          </tr>
          <tr>
            <td>${transData.orderdate}</td>
            <td class="text-right">${payload.orderdate || ''}</td>
          </tr>
        </table>
        <table style="width: 100%">
          <tr>
            <td width="50%">${transData.shipment}:</td>
            <td width="50%" class="text-right">${payload.shipmentname || ''}</td>
          </tr>
          <tr>
            <td>${transData.sendingWeek}:</td>
            <td class="text-right">${payload.sendfrom_warehouse || ''}</td>
          </tr>
          <tr>
            <td>${transData.installationWeek}:</td>
            <td class="text-right">${payload.installation_week || ''}</td>
          </tr>
          <tr>
            <td>${transData.orderSum}:</td>
            <td class="text-right">${payload.totalexvat || ''}</td>
          </tr>
        </table>
      </div>

      <div class="col-xs-12 table-content" style="padding-top: 5px;">
        <table class="table table-condensed" style="width: 100%">
          <thead>
            <tr>
              ${headers}
            </tr>
          </thead>
          <tbody>
            ${content}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</body>
</html>`)))
export default processOrderPurchaseList
